import { useEffect, useState } from "react";
import { ItemCatalogo } from "../models/administracion/ItemCatalogo";
import { MonitoreoService } from "../service/monitoreo/MonitoreoService";
import { GenericComponent } from "./GenericComponent";
import { useForm } from "react-hook-form";
import { InputComponent } from "./InputComponent";
import { confirmDialog } from "primereact/confirmdialog";
import { Card } from "primereact/card";
import { Toolbar } from "primereact/toolbar";
import { Dialog } from "primereact/dialog";
import { Generico } from "./Generico";

export const Catalogo = ({permss, toast, urls, opcion}) => {
    const generic = new GenericComponent();
    const { accionesTbl } = Generico();
    const omodel = new ItemCatalogo();
    const catalogSrv = new MonitoreoService();
    const defaultValues = generic.default(omodel.model);
    const { control, formState: { errors }, handleSubmit, reset, setError, getValues } = useForm({ defaultValues });
    const [registros, setRegistros] = useState(null);
    const [item, setItem] = useState(null);
    const [dialogCatalogo, setDialogCatalogo] = useState(false);
    const { table, setLoading, setTotalRecords, lazyParams, inDrop, inText, inNumber } =
        InputComponent({ registers: registros, omodel, generic, errors, control, id: getValues('id'), permss });

    useEffect(() => {
        loadLazyData();
    }, [lazyParams]);

    const loadLazyData = () => {
        setLoading(true);
        let _lazyParams = lazyParams;
        catalogSrv.listado(urls?.listar, { lazyEvent: JSON.stringify(_lazyParams) }).then(res => {
            setTotalRecords(res.data.total);
            setRegistros(res.data.registros);
            setLoading(false);
        });
    }

    const openNew = () => {
        setDialogCatalogo(true);
        reset(defaultValues);
    }

    const onSubmit = (data) => {
        if (getValues('id') == null) {
            catalogSrv.nuevo(data, urls?.nuevo).then(res => {
                setDialogCatalogo(false);
                loadLazyData();
                generic.funcSuccess(res, toast);
            }).catch(error => {
                generic.funcError(error, toast, setError);
            });
        }
        else {
            catalogSrv.editar(data, urls?.editar).then(res => {
                setDialogCatalogo(false);
                loadLazyData();
                generic.funcSuccess(res, toast);
            }).catch(error => {
                generic.funcError(error, toast, setError);
            });
        }
    }

    const editar = () => {
        catalogSrv.consultar(item.id, urls?.consultar).then(res => {
            const _catalogo = res.data;
            const lista = {};
            if (opcion?.estado) lista.estado = generic.estados;
            if (opcion?.activado) lista.activado = generic.sino;
            if (opcion?.mostrar) lista.mostrar = generic.sino;

            Object.keys(lista).forEach(function (key) {
                if (_catalogo[key] != null) {
                    lista[key].forEach(element => {
                        if (element.cat_id === _catalogo[key]) {
                            _catalogo[key] = element;
                        }
                    });
                }
            });
            reset(_catalogo);
            setDialogCatalogo(true);
        });
    }

    const confirmDelete = () => {
        confirmDialog({
            message: '¿Está seguro de eliminar?',
            header: 'Confirmación',
            icon: 'pi pi-exclamation-triangle',
            accept: () => eliminar()
        });
    }

    const eliminar = () => {
        catalogSrv.eliminar(item.id, urls?.eliminar).then(res => {
            loadLazyData();
            generic.funcSuccess(res, toast);
        }).catch(error => {
            generic.funcDeleteError(error, toast);
        });
    }

    const onError = (error) => {
        toast.current.show({ severity: 'error', summary: 'Error', detail: 'Se han detectado errores. Por favor, revise la información ingresada y proceda a corregir', life: 3000 });
    }

    const itemsMenu = () => {
        const items = [];
        if (permss?.actualizar)
            items.push({ label: 'Editar', icon: 'pi pi-pencil', command: () => { editar() } });
        if (permss?.eliminar)
            items.push({ label: 'Eliminar', icon: 'pi pi-trash', command: () => { confirmDelete() } });

        return [{ label: 'Opciones', items: items }];
    }

    return (
        <>
            <Card style={{ maxWidth: '100%', margin: 'auto' }}>
                <Toolbar className="mb-4" start={generic.leftToolbarTemplate(openNew, '', permss)} ></Toolbar>
                {table({ action01: accionesTbl, reg: setItem, items: itemsMenu() })}
            </Card>

            <Dialog visible={dialogCatalogo} header={getValues('id') == null ? "Nuevo" : "Editar"} modal className="p-fluid modal-ssize" onHide={e => setDialogCatalogo(false)}
                style={{ maxWidth: '400px' }}>
                <form onSubmit={handleSubmit(onSubmit, onError)}>
                    <div className="formgrid grid">
                        {inText('nombre', {}, 12)}
                        {inText('descripcion', {}, 12)}
                        {opcion?.nemonico && inText('nemonico', {}, 12)}
                        {opcion?.valor && inText('valor', {}, 6)}
                        {opcion?.orden && inNumber('valor', 0, false, { min: 0 }, 6)}
                        {opcion?.estado && inDrop('estado', generic.estados, { lab: omodel.optionLabel }, 6)}
                        {opcion?.mostrar && inDrop('estado', generic.sino, { lab: omodel.optionLabel }, 6)}
                        {opcion?.activado && inDrop('estado', generic.sino, { lab: omodel.optionLabel }, 6)}
                    </div>

                    {generic.buttonsForms(setDialogCatalogo)}
                </form>
            </Dialog>
        </>
    )
}
